import React, { useEffect, useState, useRef, useMemo, memo } from "react";
import moment from "moment";
import ReactApexChart from "react-apexcharts";
import "../styles.css";

const getProgressBarColor = (percentage) => {
  if (percentage >= 80) return "progress-bar-green";
  if (percentage >= 75) return "progress-bar-yellow";
  if (percentage >= 70) return "progress-bar-orange";
  return "progress-bar-red";
};

const getRowClassncHar = (nc) => {
  return nc > 0 ? "row-red-nc" : "";
};

const getRowClassncHar2 = (taux_conversion_year) => {
  return taux_conversion_year > 0 ? "row-green-conversion" : "row-red-conversion";
};

const useIsMounted = (logLabel) => {
  const isMounted = useRef(Math.floor(Math.random() * 10000 + 1));
  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, [logLabel]);
  return isMounted;
};

const CircularProgressChart = memo(({ percentage, avatar, name, size = "large" }) => {
  const getColor = (percentage) => {
    if (percentage >= 80) return "#4CAF50"; // Green
    if (percentage >= 50) return "#FFC107"; // Yellow
    return "#F44336"; // Red
  };

  const chartSize = size === "small" ? 95 : 200;
  const fontSize = size === "small" ? "18px" : "20px";
  const hollowSize = size === "small" ? "50%" : "60%";

  const options = {
    chart: { type: "radialBar" },
    plotOptions: {
      radialBar: {
        hollow: { size: hollowSize },
        dataLabels: { name: { show: false }, value: { show: false } },
      },
    },
    fill: { colors: [getColor(percentage)] },
    stroke: { lineCap: "round" },
    labels: [`${name}`],
  };

  return (
    <div className={`radial-chart-container ${size}`}>
      <div className="chart-wrapper">
        <ReactApexChart options={options} series={[percentage]} type="radialBar" height={chartSize} width={chartSize} />
        <div className="chart-percentage" style={{ fontSize }}></div>
      </div>
      {size === "small" && <img src={avatar} alt={name} className="chart-avatar" />}
      {size === "large" && (
        <div className="chart-content">
          <img src={avatar} alt={name} className="chart-avatar" />
          <div className="chart-percentage_text" style={{ fontSize }}>&emsp;{percentage}%</div>
        </div>
      )}
    </div>
  );
});
const CircularProgressChart1 = memo(({ percentage, avatar, name, size = "large" }) => {
  const getColor = (percentage) => {
    if (percentage >= 80) return "#4CAF50"; // Green
    if (percentage >= 50) return "#FFC107"; // Yellow
    return "#F44336"; // Red
  };

  const chartSize = size === "small" ? 95 : 200;
  const fontSize = size === "small" ? "18px" : "20px";
  const hollowSize = size === "small" ? "50%" : "60%";

  const options = {
    chart: { type: "radialBar" },
    plotOptions: {
      radialBar: {
        hollow: { size: hollowSize },
        dataLabels: { name: { show: false }, value: { show: false } },
      },
    },
    fill: { colors: [getColor(percentage)] },
    stroke: { lineCap: "round" },
    labels: [`${name}`],
  };

  return (
    <div className={`radial-chart-container ${size}`}>
      <div className="chart-wrapper">
        <ReactApexChart options={options} series={[percentage]} type="radialBar" height={chartSize} width={chartSize} />
        <div className="chart-percentage" style={{ fontSize }}></div>
      </div>
      {size === "small" && <img src={avatar} alt={name} className="chart-avatar" />}
      {size === "large" && (
        <div className="chart-content">
          <img src={avatar} alt={name} className="chart-avatar" />
          <div className="chart-percentage_text" style={{ fontSize }}>{percentage}%</div>
        </div>
      )}
    </div>
  );
});

const TeamFlow = () => {
  const [teamData, setTeamData] = useState(null);
  const [sourcingData, setSourcingData] = useState(null);
  const [appeldeoffreData, setAppeldeoffreData] = useState(null);
  const [responsablesData, setResponsablesData] = useState(null); // New state for responsables data
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [previousWeeksData, setPreviousWeeksData] = useState([]);
  const isMountedRef = useIsMounted("blah");
  const [timer, setTimer] = useState(60);
  const [harmonisationData, setHarmonisationData] = useState(null);
  const [comptabiliteData, setComptabiliteData] = useState(null);
  const [winners, setWinners] = useState([]);
  const [winner, setWinner] = useState(null);

  const resetLocalStorageIfNewWeek = () => {
    const lastResetDate = localStorage.getItem("lastResetDate");
    const currentDate = moment().format("YYYY-MM-DD");
    if (!lastResetDate || moment(currentDate).diff(moment(lastResetDate), "weeks") >= 1) {
      localStorage.removeItem("lastWinnerId");
      localStorage.setItem("lastResetDate", currentDate);
    }
  };

  // Original memoized calculations (unchanged)
  const halimaPercentageOriginal = useMemo(() => {
    if (!sourcingData?.marketing || sourcingData.marketing.length === 0) {
      return 0;
    }
    const halima = sourcingData.marketing.find(
      (member) => member.prenom === "Halima" && member.nom === "ELMADKOURI"
    );
    if (!halima) {
      return 0;
    }
    const valueToCalculate = halima.c_new || 0;
    const denominator = 10;
    return (valueToCalculate / denominator) * 100;
  }, [sourcingData?.marketing]);

  const frontofficepercentage = useMemo(() => {
    return sourcingData?.front_office?.map((member) => ({
      ...member,
      percentage: (member.dp / 300) * 100,
    })) || [];
  }, [sourcingData?.front_office]);

  const meriemPercentageOriginal = useMemo(() => {
    return sourcingData?.cam || 0;
  }, [sourcingData?.cam]);

  const appelDoffrePercentageOriginal = useMemo(() => {
    return appeldeoffreData?.taux_reponse.taux || 0;
  }, [appeldeoffreData?.taux_reponse.taux]);

  // New memoized calculations for Rapport des Taux Conversion
  const halimaPercentage = useMemo(() => {
    const hafid = responsablesData?.responsables.find(
      (member) => member.prenom === "Hafid" && member.nom === "ELHAOUAF"
    );
    return hafid ? hafid.taux_conversion: 0;
  }, [responsablesData]);

  const meriemPercentage = useMemo(() => {
    const meryem = responsablesData?.responsables.find(
      (member) => member.prenom === "Meryem" && member.nom === "RAHIB"
    );
    return meryem ? meryem.taux_conversion : 0;
  }, [responsablesData]);

  const appelDoffrePercentage = useMemo(() => {
    const omar = responsablesData?.responsables.find(
      (member) => member.prenom === "OMAR" && member.nom === "BENJELOUAJA"
    );
    return omar ? omar.taux_conversion : 0;
  }, [responsablesData]);

  const hamzateamMembersPercentages = useMemo(() => {
    if (harmonisationData?.harmonisation) {
      return harmonisationData.harmonisation
        .map((user) => ({
          ...user,
          percentage: user.taux_rapidite_week || 0,
        }))
        .sort((a, b) => b.percentage - a.percentage);
    }
    return [];
  }, [harmonisationData?.harmonisation]);

  const reloadPage = () => {
    window.location.reload();
  };

  const checkWinner = (currentWeekMember, previousWeekMember) => {
    const currentWeekCriteria = currentWeekMember.dvTotal >= 30 && currentWeekMember.taux >= 95;
    const previousWeekCriteria = previousWeekMember?.taux >= 85;
    return currentWeekCriteria && previousWeekCriteria;
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setTimer((prevTimer) => {
        if (prevTimer === 0) {
          clearInterval(interval);
          reloadPage();
          return 0;
        }
        return prevTimer - 1;
      });
    }, 2000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (teamData && previousWeeksData.length > 0) {
      const newWinners = [];
      const commercialMembers = commercialTeamWithManager.filter((member) => member.id_user >= 0);
      commercialMembers.forEach((member) => {
        const previousWeekMember = previousWeeksProcessed[0]?.commercial.find(
          (m) => m.id_user === member.id_user
        );
        if (checkWinner(member, previousWeekMember)) {
          newWinners.push(member);
        }
      });

      if (newWinners.length > 0) {
        const firstWinner = newWinners[0];
        const storedWinnerId = localStorage.getItem("lastWinnerId");
        if (storedWinnerId !== String(firstWinner.id_user)) {
          setWinner(firstWinner);
          localStorage.setItem("lastWinnerId", firstWinner.id_user);
          setTimeout(() => {
            setWinner(null);
          }, 15000);
        }
      }
    }
  }, [teamData, previousWeeksData]);

  useEffect(() => {
    resetLocalStorageIfNewWeek();
  }, []);

  const getFridaysFromDate = (date, weeks = 2) => {
    const startDate = moment(date);
    const fridays = [];
    let firstFriday = startDate.clone().day(5);
    if (firstFriday.isAfter(startDate)) {
      firstFriday = firstFriday.subtract(1, "weeks");
    }
    for (let i = 0; i < weeks; i++) {
      fridays.push(firstFriday.clone().subtract(i, "weeks").format("YYYY-MM-DD"));
    }
    return fridays;
  };
  const proxyBase = "https://corss-smoky.vercel.app/api/proxy?url=";
  useEffect(() => {
    const fetchData = async () => {
      try {
        const currentWeekUrl = "https://test.eurodistech.com/storage/json/commercial-detail.json";
        const ncUrl = "https://test.eurodistech.com/storage/json/reclamation.json";
        const sourcingUrl = "https://test.eurodistech.com/storage/json/sourcing.json";
        const comptabiliteUrl = "https://test.eurodistech.com/storage/json/compabilite.json";
        const appeldeoffre = "https://test.eurodistech.com/storage/json/expiring-demandes.json";
        const responsablesUrl = "https://test.eurodistech.com/storage/json/responsbles.json"; // New API

        const fridays = getFridaysFromDate(moment().format("YYYY-MM-DD"), 2);
        const weekUrls = fridays.map(
          (date) => `https://test.eurodistech.com/storage/json/historique/commercial-detail-${date}.json`
        );

        const responses = await Promise.all(
          [currentWeekUrl, weekUrls[0], weekUrls[1], ncUrl, sourcingUrl, comptabiliteUrl, appeldeoffre, responsablesUrl].map((url) =>
            fetch(`${proxyBase}${encodeURIComponent(url)}`)
            .then((res) => res.json())
          )
        );

        setTeamData(responses[0]);
        setSourcingData(responses[4]);
        setPreviousWeeksData(responses.slice(1, 3));
        setHarmonisationData(responses[4]);
        setComptabiliteData(responses[5]);
        setAppeldeoffreData(responses[6]);
        setResponsablesData(responses[7]); // Set new responsables data

        setLoading(false);
      } catch (error) {
        setError(error.message);
        setLoading(false);
      }
    };

    if (isMountedRef.current) {
      fetchData();
    }
  }, []);

  const calculateCumulativeValuesForWeek = (member) => {
    const dpTotal =
      member.dp_monday + member.dp_tuesday + member.dp_wednesday + member.dp_thursday + member.dp_friday;
    const dvTotal =
      member.dv_monday + member.dv_tuesday + member.dv_wednesday + member.dv_thursday + member.dv_friday;
    const taux = dpTotal === 0 ? 0 : ((dvTotal / dpTotal) * 100).toFixed(2);
    return { dpTotal, dvTotal, taux };
  };

  const calculateManagerValuesForWeek = (team) => {
    const managerTotals = team.reduce(
      (acc, member) => {
        const { dpTotal, dvTotal } = calculateCumulativeValuesForWeek(member);
        acc.dpTotal += dpTotal;
        acc.dvTotal += dvTotal;
        return acc;
      },
      { dpTotal: 0, dvTotal: 0 }
    );
    const taux = managerTotals.dpTotal === 0 ? 0 : ((managerTotals.dvTotal / managerTotals.dpTotal) * 100).toFixed(2);
    return { ...managerTotals, taux };
  };

  const dayName = moment().format("dddd");

  const calculateCumulativeValues = (member, tt = false) => {
    let dpTotal = 0;
    let dvTotal = 0;

    if (tt) {
      dpTotal = member.dp_monday + member.dp_tuesday + member.dp_wednesday + member.dp_thursday + member.dp_friday;
      dvTotal = member.dv_monday + member.dv_tuesday + member.dv_wednesday + member.dv_thursday + member.dv_friday;
      const taux = dpTotal === 0 ? 0 : ((dvTotal / dpTotal) * 100).toFixed(2);
      return { dpTotal, dvTotal, taux };
    }

    switch (dayName) {
      case "Monday":
        dpTotal = member.dp_monday;
        dvTotal = member.dv_monday;
        break;
      case "Tuesday":
        dpTotal = member.dp_monday + member.dp_tuesday;
        dvTotal = member.dv_monday + member.dv_tuesday;
        break;
      case "Wednesday":
        dpTotal = member.dp_monday + member.dp_tuesday + member.dp_wednesday;
        dvTotal = member.dv_monday + member.dv_tuesday + member.dv_wednesday;
        break;
      case "Thursday":
        dpTotal = member.dp_monday + member.dp_tuesday + member.dp_wednesday + member.dp_thursday;
        dvTotal = member.dv_monday + member.dv_tuesday + member.dv_wednesday + member.dv_thursday;
        break;
      case "Friday":
        dpTotal = member.dp_monday + member.dp_tuesday + member.dp_wednesday + member.dp_thursday + member.dp_friday;
        dvTotal = member.dv_monday + member.dv_tuesday + member.dv_wednesday + member.dv_thursday + member.dv_friday;
        break;
      default:
        dpTotal = 0;
        dvTotal = 0;
        break;
    }

    const taux = dpTotal === 0 ? 0 : ((dvTotal / dpTotal) * 100).toFixed(2);
    return { dpTotal, dvTotal, taux };
  };

  const audioPlayed = useRef(false);
  const processTeamData = (team, tt = false, ncData = []) => {
    return team.map((member) => {
      const { dpTotal, dvTotal, taux } = calculateCumulativeValues(member, tt);
      const ncMember = ncData.find((nc) => nc.id_user === member.id_user);
      const ncValue = ncMember ? ncMember.nc : 0;
  
      // Use taux_conversion from commercial data if available
      let taux_conversion = member.taux_conversion || 0;
  
      // Fallback to responsablesData if not found in commercial
      if (!taux_conversion && responsablesData?.responsables) {
        // Try matching by ID
        const responsableById = responsablesData.responsables.find(
          (r) => r.id_user === member.id_user
        );
  
        // Try matching by name (case-insensitive, trimmed)
        const responsableByName = responsablesData.responsables.find((r) => {
          const memberName = member.full_name?.toLowerCase().trim();
          const responsableName = `${r.prenom} ${r.nom}`.toLowerCase().trim();
          return memberName === responsableName;
        });
  
        taux_conversion = responsableById?.taux_conversion || responsableByName?.taux_conversion || 0;
      }
  
      return { ...member, dpTotal, dvTotal, taux, nc: ncValue, taux_conversion };
    });
  };

  const calculateManagerValues = (team) => {
    const managerTotals = team.reduce(
      (acc, member) => {
        const { dpTotal, dvTotal, nc } = calculateCumulativeValues(member);
        acc.dpTotal += dpTotal;
        acc.dvTotal += dvTotal;
        acc.ncTotal += nc || 0;
        return acc;
      },
      { dpTotal: 0, dvTotal: 0, ncTotal: 0 }
    );
    const taux = managerTotals.dpTotal === 0 ? 0 : ((managerTotals.dvTotal / managerTotals.dpTotal) * 100).toFixed(2);
    return { ...managerTotals, taux };
  };

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;
  if (!teamData || !sourcingData || !responsablesData) return <div>No data available</div>;

  const commercialTeam = processTeamData(teamData.commercial);
  const sourcingTeam = processTeamData(teamData.sourcing);
  const relanceTeam = processTeamData(teamData.relance);

  const sourcingManager = calculateManagerValues(teamData.sourcing);
  const relanceManager = calculateManagerValues(teamData.relance);
  const commercialManager = calculateManagerValues(teamData.commercial);

  const sourcingTeamWithManager = [
    ...sourcingTeam,
    { full_name: "Hafid ELHAOUAF (Manager)", dpTotal: sourcingManager.dpTotal, dvTotal: sourcingManager.dvTotal, taux: sourcingManager.taux, avatar: "elhaouaf-hafid-29-thumb.jpg", id_user: -1 },
  ];

  const relanceTeamWithManager = [
    ...relanceTeam,
    { full_name: "Omar BENJELOUAJA (Manager)", dpTotal: relanceManager.dpTotal, dvTotal: relanceManager.dvTotal, taux: relanceManager.taux, avatar: "https://www.shutterstock.com/image-vector/default-avatar-profile-icon-vector-600nw-1745180411.jpg", id_user: -2 },
  ];

  const commercialTeamWithManager = [
    ...commercialTeam,
    { 
      full_name: "Meriem RAHIB (Manager)", 
      dpTotal: commercialManager.dpTotal, 
      dvTotal: commercialManager.dvTotal, 
      taux: commercialManager.taux, 
      avatar: "rahib-meryem-25-thumb.jpg", 
      nc: commercialManager.ncTotal, 
      id_user: -3,
      taux_conversion: meriemPercentage // Use the already calculated manager percentage
    },
  ];

  const previousWeeksProcessed = previousWeeksData.map((weekData) => {
    const commercialTeam = processTeamData(weekData.commercial, true);
    const sourcingTeam = processTeamData(weekData.sourcing, true);
    const relanceTeam = processTeamData(weekData.relance, true);

    const sourcingManager = calculateManagerValuesForWeek(weekData.sourcing);
    const relanceManager = calculateManagerValuesForWeek(weekData.relance);
    const commercialManager = calculateManagerValuesForWeek(weekData.commercial);

    return {
      commercial: [...commercialTeam, { full_name: "Meriem RAHIB (Manager)", dpTotal: commercialManager.dpTotal, dvTotal: commercialManager.dvTotal, taux: commercialManager.taux, avatar: "rahib-meryem-25-thumb.jpg", nc: commercialManager.ncTotal, id_user: -3 }],
      sourcing: [...sourcingTeam, { full_name: "Hafid ELHAOUAF (Manager)", dpTotal: sourcingManager.dpTotal, dvTotal: sourcingManager.dvTotal, taux: sourcingManager.taux, avatar: "elhaouaf-hafid-29-thumb.jpg", id_user: -1 }],
      relance: [...relanceTeam, { full_name: "Omar BENJELOUAJA (Manager)", dpTotal: relanceManager.dpTotal, dvTotal: relanceManager.dvTotal, taux: relanceManager.taux, avatar: "https://www.shutterstock.com/image-vector/default-avatar-profile-icon-vector-600nw-1745180411.jpg", id_user: -2 }],
      date: weekData.date,
    };
  });

  const renderTeamTable = (team, teamName, managerName) => {
    if (!team || !Array.isArray(team)) {
      return <div>No data available for {teamName}.</div>;
    }

    const managers = team.filter((member) => member.id_user < 0);
    const teamMembers = team.filter((member) => member.id_user >= 0);
    const sortedTeamMembers = [...teamMembers, ...managers].sort((a, b) => b.taux - a.taux);
    const sortedTeam = [...sortedTeamMembers];

    let teamKey;
    switch (teamName.toLowerCase()) {
      case "relance team":
        teamKey = "relance";
        break;
      case "sourcing team":
        teamKey = "sourcing";
        break;
      case "commercials team":
        teamKey = "commercial";
        break;
      default:
        teamKey = teamName.toLowerCase().split(" ")[0];
    }

    const nextWeekData = teamData[`${teamKey}_next`] || [];
    const sortedNextWeekData = nextWeekData.map((member) => {
      const dpTotal =
        member.dp_monday + member.dp_tuesday + member.dp_wednesday + member.dp_thursday + member.dp_friday;
      const dvTotal =
        member.dv_monday + member.dv_tuesday + member.dv_wednesday + member.dv_thursday + member.dv_friday;
      const taux = dpTotal === 0 ? 0 : ((dvTotal / dpTotal) * 100).toFixed(2);
      return { ...member, dpTotal, dvTotal, taux };
    });

    const managerTotalsNextWeek = sortedNextWeekData.reduce(
      (acc, member) => {
        acc.dpTotal += member.dpTotal;
        acc.dvTotal += member.dvTotal;
        return acc;
      },
      { dpTotal: 0, dvTotal: 0 }
    );

    const managerTauxNextWeek =
      managerTotalsNextWeek.dpTotal === 0
        ? 0
        : ((managerTotalsNextWeek.dvTotal / managerTotalsNextWeek.dpTotal) * 100).toFixed(2);

    const nextWeekWithManager = [
      ...sortedNextWeekData,
      { full_name: `${managerName} (Manager)`, dpTotal: managerTotalsNextWeek.dpTotal, dvTotal: managerTotalsNextWeek.dvTotal, taux: managerTauxNextWeek, avatar: managers[0]?.avatar || "", id_user: managers[0]?.id_user || -1 },
    ];

    const sortedNextWeekDataWithManager = sortedTeam.map((currentMember) =>
      nextWeekWithManager.find((member) => member.id_user === currentMember.id_user)
    );

    const yearData = teamData[`${teamKey}_year`] || [];
    const sortedYearData = yearData.map((member) => {
      const taux = member.dp === 0 ? 0 : ((member.dv / member.dp) * 100).toFixed(2);
      return { ...member, taux };
    });

    const managerTotalsYear = sortedYearData.reduce(
      (acc, member) => {
        acc.dpTotal += member.dp;
        acc.dvTotal += member.dv;
        return acc;
      },
      { dpTotal: 0, dvTotal: 0 }
    );

    const managerTauxYear =
      managerTotalsYear.dpTotal === 0
        ? 0
        : ((managerTotalsYear.dvTotal / managerTotalsYear.dpTotal) * 100).toFixed(2);

    const yearWithManager = [
      ...sortedYearData,
      { full_name: `${managerName} (Manager)`, dpTotal: managerTotalsYear.dpTotal, dvTotal: managerTotalsYear.dvTotal, taux: managerTauxYear, id_user: managers[0]?.id_user || -1 },
    ];

    const sortedYearDataWithManager = sortedTeam.map((currentMember) =>
      yearWithManager.find((member) => member.id_user === currentMember.id_user)
    );

    const getRowClass = (index) => {
      const taux = sortedTeamMembers[index]?.taux || 0;
      if (taux >= 80) return "row-green";
      if (taux >= 75) return "row-yellow";
      if (taux >= 70) return "row-orange";
      return "row-red";
    };

    const getRowClassnc = (index) => {
      const nc = sortedTeamMembers[index]?.nc_week || 0;
      const taux = sortedTeamMembers[index]?.taux || 0;
      if (nc > 0) return "row-red-nc";
      if (taux >= 80) return "row-green";
      if (taux >= 75) return "row-yellow";
      if (taux >= 70) return "row-orange";
      return "row-red";
    };

    const getAvatarClass = (taux) => {
      if (taux >= 80) return "avatar-green";
      if (taux >= 75) return "avatar-yellow";
      if (taux >= 70) return "avatar-orange";
      return "avatar-red";
    };

    const getThClass = (taux) => {
      if (taux >= 80) return "th-green";
      if (taux >= 75) return "th-yellow";
      if (taux >= 70) return "th-orange";
      return "th-red";
    };
    const getThClass2 = (taux) => {
      if (taux >= 0) return "th-green";
      return "th-red";
    };





    return (
      <div>
        <table className="team-table">
          <thead>
            <tr>
              <th></th>
              {sortedTeam.map((member, index) => (
                <th key={`header-${index}`} className={
                  teamName 
                    ? getThClass2(member.taux_conversion) 
                    : getThClass(member.taux) // Fallback to taux-based styling for other teams
                }>
                <img
                  src={`https://www.eurodistech.com/erp/public/assets/images/avatars/${member.avatar}`}
                  alt={member.full_name}
                  className={`avatar ${getAvatarClass(member.taux)} ${winners.includes(member.id_user) ? "winner" : ""}`}
                  onError={(e) => {
                    e.currentTarget.onerror = null; // Prevent infinite loop
                    e.currentTarget.src =`${member.avatar}`;
                  }}
                />

                {teamName  && (
                  <h5 style={{ color: "black", fontWeight: "bold" }} >
                    Taux Conversion <br />
                    {member.taux_conversion ? parseFloat(member.taux_conversion).toFixed(2) : "0"}%
                  </h5>
                )}
              </th>
              ))}
            </tr>
          </thead>
          <tbody>
            <tr>
            <td>This Year</td>
              {sortedYearDataWithManager.map((member, index) => (
                <td key={`data-${index}`} style={{ textAlign: "center" }} className={getRowClass(index)}>
                  {sortedYearDataWithManager[index]?.taux || "N/A"}%
                </td>
              ))}
            </tr>
            <tr>
              <td>S</td>
              {sortedTeam.map((member, index) => (
                <td key={`data-${index}`} className={getRowClass(index)}>
                  <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <div>DV: {member ? member.dvTotal : "N/A"}</div>
                    <div style={{ borderLeft: "2px solid black", height: "20px", margin: "0 8px" }}></div>
                    <div>DP: {member ? member.dpTotal : "N/A"}</div>
                  </div>
                  <hr style={{ margin: "4px 0", border: "1px solid black" }} />
                  <div style={{ textAlign: "center" }}>{member ? `${member.taux}%` : "N/A"}</div>
                </td>
              ))}
            </tr>
            {previousWeeksProcessed.map((week, weekIndex) => {
              const weekTeamData = week[teamKey];
              if (!weekTeamData || !Array.isArray(weekTeamData)) {
                console.warn(`No data available for ${teamName} in PW${weekIndex + 1}`);
                return null;
              }

              const sortedWeekTeamData = sortedTeam.map((currentMember) =>
                weekTeamData.find((member) => member.id_user === currentMember.id_user)
              );

              return (
                <tr key={`week-${weekIndex}`}>
                  <td>{weekIndex === 0 ? "S - 1" : weekIndex === 1 ? "S - 2" : "S + 1"}</td>
                  {sortedWeekTeamData.map((member, index) => (
                    <td key={`data-pw${weekIndex}-${index}`} className={getRowClass(index)}>
                      <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                        <div>DV: {member ? member.dvTotal : "N/A"}</div>
                        <div style={{ borderLeft: "2px solid black", height: "20px", margin: "0 8px" }}></div>
                        <div>DP: {member ? member.dpTotal : "N/A"}</div>
                      </div>
                      <hr style={{ margin: "4px 0", border: "1px solid black" }} />
                      <div style={{ textAlign: "center" }}>{member ? `${member.taux}%` : "N/A"}</div>
                    </td>
                  ))}
                </tr>
              );
            })}
            <tr>
              <td>S + 1</td>
              {sortedNextWeekDataWithManager.map((member, index) => (
                <td key={`data-next-${index}`} className={getRowClass(index)}>
                  <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <div>DV: {member ? member.dvTotal : "N/A"}</div>
                    <div style={{ borderLeft: "2px solid black", height: "20px", margin: "0 8px" }}></div>
                    <div>DP: {member ? member.dpTotal : "N/A"}</div>
                  </div>
                  <hr style={{ margin: "4px 0", border: "1px solid black" }} />
                  <div style={{ textAlign: "center" }}>{member ? `${member.taux}%` : "N/A"}</div>
                </td>
              ))}
            </tr>
            {teamName  && (
              <tr>
                <td>NC W</td>
                {sortedTeam.map((member, index) => (
                  <td key={`data-nc-${index}`} className={getRowClassnc(index)}>
                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", fontSize: "20px", fontWeight: "bold" }}>
                      <div>{member ? member.nc_week : "N/A"}</div>
                    </div>
                  </td>
                ))}
              </tr>
            )}
          </tbody>
        </table>
      </div>
    );
  };
const formatNumber = (value) => {
  if (value === undefined || value === null || isNaN(value)) {
    return '-'; // or use "N/A" or "0" as needed
  }
  
  if (value >= 1_000_000) {
    return `${(value / 1_000_000).toFixed(2)} M`;
  } else if (value >= 1_000) {
    return `${(value / 1_000).toFixed(2)} K`;
  } else {
    return value.toFixed(1);
  }
};

const qasbiTeamMembers = hamzateamMembersPercentages.filter(m => m.nom !== "EL-QASBY");

const totalCmdWeek = qasbiTeamMembers.reduce((sum, m) => sum + Number(m.cmd_week), 0);
const totalCmdWeek1 = qasbiTeamMembers.reduce((sum, m) => sum + Number(m.cmd_week_1), 0);
const totalCmdYearWeek = qasbiTeamMembers.reduce((sum, m) => sum + Number(m.cmd_year_week), 0);
const totalCmdYearWeek1 = qasbiTeamMembers.reduce((sum, m) => sum + Number(m.cmd_year_week_1), 0);
const totalNcWeek = qasbiTeamMembers.reduce((sum, m) => sum + Number(m.nc_week), 0);



  return (
    <div className="App">
      {winner && (() => {
        if (!audioPlayed.current) {
          const audio = new Audio("/Zaghrouta maghribiya.mp3");
          audio.play().catch((error) => console.error("Playback error:", error));
          audioPlayed.current = true;
        }
        return (
          <div className="overlay">
            <div className="winner-display">
              <img src={`https://www.eurodistech.com/erp/public/assets/images/avatars/${winner.avatar}`} alt={winner.full_name} />
              <h1 style={{ color: "white" }}>👏 Félicitations {winner.full_name} 🎉🏆</h1>
            </div>
          </div>
        );
      })()}

      {renderTeamTable(commercialTeamWithManager, "Commercials Team", "Meriem RAHIB")}
      <div className="two-tables-container">
        {renderTeamTable(relanceTeamWithManager, "Relance Team", "Omar BENJELOUAJA")}
        {renderTeamTable(sourcingTeamWithManager, "Sourcing Team", "Hafid ELHAOUAF")}
      </div>

      <div className="downtables">
        <table className="team-table-chart harmonisation-table">
          <thead >
            <tr>
              <th style={{ color: "black", fontWeight: "bold" ,fontSize:"20px" }}>Harmonisation</th>
              <th style={{ color: "black", fontWeight: "bold" ,fontSize:"15px" }}>   Taux Week   </th>
              <th style={{ color: "black", fontWeight: "bold" ,fontSize:"15px" }}>   Taux Week-1   </th>
              <th style={{ color: "black", fontWeight: "bold" ,fontSize:"17px" }}>   Taux Year  </th>
              <th style={{ color: "black", fontWeight: "bold" ,fontSize:"15px" }}>Taux de Conversion</th>
              <th style={{ color: "black", fontWeight: "bold" ,fontSize:"15px" }}>N&M C Week | N&M C Week-1</th>
              <th style={{ color: "black", fontWeight: "bold" ,fontSize:"15x"}}>NC Week</th>
            </tr>
          </thead>
          <tbody>
            {hamzateamMembersPercentages
              .sort((a, b) => b.percentage - a.percentage)
              .map((member) => (
                <tr key={member.id_user}>
                  <td className="tdavatarteamtable">
                    <img
                      src={`https://www.eurodistech.com/erp/public/assets/images/avatars/${member.avatar}`}
                      className="avatarteamtable"
                      alt={`${member.prenom} ${member.nom}`}
                    />
                  </td>
                  <td>
                    <div className="progress-bar-container">
                      <div
                        className={`progress-bar ${getProgressBarColor(member.taux_rapidite_week)}`}
                        style={{ width: `${member.taux_rapidite_week}%` }}
                      ></div>
                      <span>{member.taux_rapidite_week.toFixed(2)}%</span>
                    </div>
                    <div className="d-flex justify-content-center align-items-center">
                        <span className="badge bg-primary me-2">
                          {member.nbr_harmonisation_traiter_dans_delais_week}
                        </span>
                        <span className="text-muted">|</span>
                        <span className="badge bg-secondary ms-2">
                          {member.nbr_harmonisation_week}
                        </span>
                    </div>
                  </td>
                  <td>
                    <div className="progress-bar-container">
                      <div
                        className={`progress-bar ${getProgressBarColor(member.taux_rapidite_week_1)}`}
                        style={{ width: `${member.taux_rapidite_week_1}%` }}
                      ></div>
                      <span>{member.taux_rapidite_week_1?.toFixed(2)}%</span>
                    </div>
                                        <div className="d-flex justify-content-center align-items-center">
                        <span className="badge bg-primary me-2">
                          {member.nbr_harmonisation_traiter_dans_delais_week_1}
                        </span>
                        <span className="text-muted">|</span>
                        <span className="badge bg-secondary ms-2">
                          {member.nbr_harmonisation_week_1}
                        </span>
                    </div>
                  </td>
                  <td>
                    <div className="progress-bar-container">
                      <div
                        className={`progress-bar ${getProgressBarColor(member.taux_rapidite_year)}`}
                        style={{ width: `${member.taux_rapidite_year}%` }}
                      ></div>
                      <span>{member.taux_rapidite_year.toFixed(2)}%</span>
                    </div>
                  </td>
                  <td className={getRowClassncHar2(member.taux_conversion_year)} style={{ fontSize: "20px", fontWeight: "bold" }}>
                    {member.taux_conversion_year?.toFixed(2)}%
                  </td>
                  <td>
                    <div >
                      <div className="progress" style={{ height: '45px', fontSize: '20px', fontWeight: 'bold' }}>
                        <div 
                          className="progress-bar bg-dark d-flex align-items-center justify-content-center"
                          style={{ width: '45%' }}
                        >
                          {member.cmd_week}
                        </div>
                        <div className="progress-bar bg-transparent d-flex align-items-center justify-content-center"
                          style={{ width: '10%' }}></div>
                        <div 
                          className="progress-bar bg-dark d-flex align-items-center justify-content-center"
                          style={{ width: '45%' }}
                        >
                          {member.cmd_week_1}
                        </div>
                      </div><br />
                  {member.nom !== "EL-QASBY" && (
                      <div className="progress" style={{ height: '45px', fontSize: '19px', fontWeight: 'bold' }}>
                        <div 
                          className="progress-bar bg-secondary d-flex align-items-center justify-content-center"
                          style={{ width: '100%' }}
                        >
                          &emsp;{formatNumber(member.cmd_year_week)}&emsp;
                        </div>
                        <div className="progress-bar bg-transparent d-flex align-items-center justify-content-center"
                          style={{ width: '10%' }}></div>
                        <div 
                          className="progress-bar bg-secondary d-flex align-items-center justify-content-center"
                          style={{ width: '100%' }}
                        >
                          {formatNumber(member.cmd_year_week_1)}
                        </div>
                      </div>
                  )}
                    {member.nom == "EL-QASBY" && (
                      <div className="progress" style={{ height: '45px', fontSize: '19px', fontWeight: 'bold' }}>
                        <div 
                          className="progress-bar bg-secondary d-flex align-items-center justify-content-center"
                          style={{ width: '100%' }}
                        >
                          {formatNumber(totalCmdYearWeek)}
                        </div>
                        <div className="progress-bar bg-transparent d-flex align-items-center justify-content-center"
                          style={{ width: '10%' }}></div>
                        <div 
                          className="progress-bar bg-secondary d-flex align-items-center justify-content-center"
                          style={{ width: '100%' }}
                        >
                          {formatNumber(totalCmdYearWeek1)}
                        </div>
                      </div>
                  )}
                    </div>
                  </td>
                  {member.nom !== "EL-QASBY" && ( 
                      <td className={getRowClassncHar(member.nc_week)} style={{ fontSize: "20px", fontWeight: "bold" }}>
                        {member.nc_week}
                      </td>
                  )}
                  {member.nom == "EL-QASBY" && ( 
                    <td className={getRowClassncHar(member.nc_week)} style={{ fontSize: "20px", fontWeight: "bold" }}>
                      {totalNcWeek}
                    </td>
                  )}
                </tr>
              ))}
          </tbody>
        </table>

        <div className="front-conversion-container">
          <table className="team-table-chart front-office-table">
            <thead>
              <tr>
                <th></th>
                <th>Front Office</th>
              </tr>
            </thead>
            <tbody>
              {frontofficepercentage
                .sort((a, b) => b.percentage - a.percentage)
                .map((member) => (
                  <tr key={member.id_user}>
                    <td className="tdavatarteamtable">
                      <img
                        src={
                          member.id_user === 19
                            ? "https://sm.approvisionneur.com/storage/customers/aIeoxtL1S3dQJXUqKRSJ2e7UOuW9dyNZD27UObkr.jpg"
                            : `https://www.eurodistech.com/erp/public/assets/images/avatars/${member.avatar}`
                        }
                        className="avatarteamtable"
                        alt={`${member.prenom} ${member.nom}`}
                      />
                    </td>
                    <td>
                      <div className="progress-bar-container">
                        <div
                          className={`progress-bar ${getProgressBarColor(member.percentage)}`}
                          style={{ width: `${member.percentage}%` }}
                        ></div>
                        <span>{member.percentage.toFixed(2)}%</span>
                      </div>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>

          <table className="team-table-chart conversion-table">
            <thead>
              <tr>
                <th><strong>Rapport des Taux Conversion</strong></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <div className="charts-wrapper">
                    <CircularProgressChart1
                      percentage={halimaPercentage.toFixed(2)}
                      avatar="https://www.eurodistech.com/erp/public/assets/images/avatars/elhaouaf-hafid-29-thumb.jpg"
                      name="Hafid ELHAOUAF"
                    />
                    <CircularProgressChart1
                      percentage={meriemPercentage.toFixed(2)}
                      avatar="https://www.eurodistech.com/erp/public/assets/images/avatars/rahib-meryem-25-thumb.jpg"
                      name="Meryem RAHIB"
                    />
                    <CircularProgressChart1
                      percentage={appelDoffrePercentage.toFixed(2)}
                      avatar="https://www.shutterstock.com/image-vector/default-avatar-profile-icon-vector-600nw-1745180411.jpg"
                      name="Omar BENJELOUAJA"
                    />
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>&emsp; &emsp; &emsp; &emsp; &emsp;

        {/* Keep the additional three CircularProgressChart components */}
        <div className="charts-wrapper">
          <CircularProgressChart
            percentage={halimaPercentageOriginal}
            avatar="https://sm.approvisionneur.com/storage/customers/aIeoxtL1S3dQJXUqKRSJ2e7UOuW9dyNZD27UObkr.jpg"
            name="Halima ELMADKOURI"
          />
                      
          <CircularProgressChart
            percentage={meriemPercentageOriginal}
            avatar="https://www.eurodistech.com/erp/public/assets/images/avatars/rahib-meryem-25-thumb.jpg"
            name="Meriem RAHIB"
          />
                     
          <CircularProgressChart
            percentage={appelDoffrePercentageOriginal}
            avatar="https://www.eurodistech.com/erp/public/assets/images/avatars/imane-mouzyad-93-thumb.jpg"
            name="Imane MOUZYAD"
          />
        </div>
      </div>
      <br />

      <div style={{ textAlign: "center", marginTop: "10px" }}>
        <p style={{ fontSize: "25px" }}>
          Page will reload in <strong style={{ color: "red" }}>{timer}</strong> seconds...
        </p>
      </div>
    </div>
  );
};

export default TeamFlow;